import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import PhoneIcon from '../../assets/icons/PhoneIcon'
import InstagramIcon from '../../assets/icons/InstagramIcon'
import YoutubeIcon from '../../assets/icons/YoutubeIcon'
import WhatsappIcon from '../../assets/icons/WhatsappIcon'
import PageTitle from '../../components/common/PageTitle'
import ProductCard from '../../components/cards/ProductCard'
import LeftImage from '../../components/common/LeftImage'
import SectionHeader from '../../components/common/SectionHeader'
import { useDispatch, useSelector } from 'react-redux'
import { getOtherProducts, getSingleData } from '../../services/actions/MainAction'

function SingleProduct() {
   
   
    const contentData = useSelector(state => state.Data.contentData);
    const otherProducts = useSelector(state => state.Data.otherProducts);
    const lang_id = useSelector(state => state.Data.lang_id);
    const [singleData, setSingleData] = useState("");
    const params = useParams();
    const dispatch = useDispatch();
    useEffect(()=>{
      window.scrollTo(0,0)
      dispatch(getSingleData(`product/${params?.id}?lang_id=${lang_id}`))
      .then(resp=>{
        setSingleData(resp);
        if(resp){
          dispatch(getOtherProducts(lang_id,resp?.id))
        }
      })
    },[params?.id, lang_id])
  return (
    <main className='mb-[50px]'>
      <PageTitle title={singleData?.translate?.title} />
      <section className='container '>
        <div className=' gap-[50px] mt-[30px] '>
            {/* <div  className='relative  flex justify-start items-start pr-[30px] pb-[30px]  mr-[50px] max-[1000px]:mr-[30px] max-[800px]:mr-0'>
              <div className='w-[300px] h-[300px] max-[950px]:w-[200px] max-[950px]:h-[200px] absolute  top-0  justify-start items-start bg-[--red]'>
              </div>
              <div>
                <img className='w-[525px] max-[800px]:w-full min-h-[423px] max-[800px]:min-h-[300px] h-auto relative top-[30px] left-[30px] max-[1000px]:top-[20px] max-[1000px]:left-[20px] ' src={singleData?.image_full_url} />
              </div>
            </div> */}
            <div className='grid grid-cols-4 gap-[20px] mb-[30px] max-[950px]:grid-cols-2 max-[550px]:grid-cols-1'>
              <img className='w-full h-[200px] max-[950px]:h-[250px]  max-[550px]:h-auto rounded-[10px]' src={singleData?.image_full_url} />
              {singleData?.image_2_full_url?<img className='w-full h-[200px] max-[950px]:h-[250px]  max-[550px]:h-auto rounded-[10px]' src={singleData?.image_2_full_url} />:null }
              {singleData?.image_3_full_url?<img className='w-full h-[200px] max-[950px]:h-[250px]  max-[550px]:h-auto rounded-[10px]' src={singleData?.image_3_full_url} />:null }
              {singleData?.image_4_full_url?<img className='w-full h-[200px] max-[950px]:h-[250px]  max-[550px]:h-auto rounded-[10px]' src={singleData?.image_4_full_url} />:null }
            
            </div>
            <div className='list-permission ' dangerouslySetInnerHTML={{__html:singleData?.translate?.description}}></div> 
        </div>
      </section>

      <div  className='container2'>
        <SectionHeader title={contentData?.other_prod} />
        <div  className='grid grid-cols-4 gap-[40px] relative mt-[30px] max-[1200px]:grid-cols-3 gap-y-[20px] max-[800px]:grid-cols-2 max-[600px]:grid-cols-1 '>
          {
            otherProducts?.map((data, i) => {
              return (
                <ProductCard key={i} data={data} />
              )
            })
          }
        </div>
      </div>
    </main>
  )
}

export default SingleProduct


/*



*/